//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CarNoInput from "@/components/carNo-input";
import Model from "@/models/yunMobile";
export default {
  components: {
    CarNoInput
  },
  data() {
    return {
      carType: "plate",
      formData: {
        carNo: "",
        unParkNo: "",
        freeDuration: "",
        busNo: ""
      },
      checkPass: false,
      checkMsg: "",
      rules: {},
      domIsvalid: false,
      domText: ""
    };
  },
  mounted() {
    Model.getCodeIsValid({
      parkNo: this.$route.params.parkNum,
      yanzheng: this.$route.params.randomNum
    }).then(res => {
      if (res.data.success) {
        this.domIsvalid = true;
      } else {
        this.domText = res.data.error;
        this.domIsvalid = false;
      }
    });
  },
  methods: {
    async getDetail() {
      const { carNo, busNo, unParkNo } = this.formData;
      const { parkNum, isCard, parkType, rulesNum } = this.$route.params;
      if (this.carType == "plate" && carNo.length < 7) {
        this.$layer.msg("请输入正确的车牌号码");
        return;
      }
      let { data } = await Model.getQrcodeFindScan({
        parkNo: parkNum, //车场编号
        isOpen: isCard, // 是否允许扫码开卡 0 否 1 是
        carType: parkType, // 车辆类型
        ruleId: rulesNum, // 计费规则编号
        carNo: carNo
      });
      if (data.success) {
        localStorage.setItem("day", carNo);
        //1是开卡，2是续费
        const { type } = data.list;

        sessionStorage.setItem("scanCodeataList", JSON.stringify(data.list));

        if (type == 1) {
          this.$router.push({
            path: "/mobile/yunMobile/openCardDetails",
            query: data.list
          });
        } else {
          this.$router.push({
            path: "/mobile/yunMobile/renewalDetails",
            query: data.list
          });
        }
      }

      data.success ? this.$layer.msg(data.msg) : this.$layer.msg(data.error);
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/mobile/yunMobile/openRenew_Card.vue